import { C as Cart } from './cart-BA5kDYZV.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class CartItemCount extends HTMLElement {
  unsubscribers = [];

  static {
    Cart.sections.push('fetch-cart-item-count');
  }

  connectedCallback() {
    ['cart:add', 'cart:update', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        Pubsub.subscribe(event, ({ sections }) => this.renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  /**
   * Parse the cart count from the HTML section
   * @param {string} html - HTML section containing cart count
   * @returns {number} Parsed cart count
   */
  getCartCount(html) {
    const { textContent } = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('cart-item-count span');

    return parseInt(textContent, 10);
  }

  /**
   * Update the cart count display
   * @param {number} count - Cart item count
   */
  updateDisplay(count) {
    const span = this.querySelector('span');
    span.textContent = count;
    this.classList.toggle('hidden', count === 0);
  }

  /**
   * Render updated cart count section
   * @param {Object} sections - Cart sections
   */
  renderSection({ 'fetch-cart-item-count': cartSection }) {
    const count = this.getCartCount(cartSection);
    this.updateDisplay(count);
  }
}

customElements.define('cart-item-count', CartItemCount);
